import React, {createContext, useCallback, useContext, useState} from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import {ConfigUpdateContextMenu} from "./ConfigUpdateContextMenu";

const NO_OP_OPEN_MENU = () => {};

const StoreTotalsContextMenuContext = createContext(NO_OP_OPEN_MENU);

export const useStoreTotalsContextMenu = () => useContext(StoreTotalsContextMenuContext);

const CLOSED_MENU = {open: false, trigger: undefined, x: 0, y: 0};

export const StoreTotalsContextMenuProvider = ({children}) => {
    const [menu, setMenu] = useState(CLOSED_MENU);

    const openMenu = useCallback((trigger, event) => {
        event.preventDefault();
        setMenu({open: true, trigger, x: event.clientX, y: event.clientY});
    }, []);

    const onOpenChange = useCallback((open) => {
        setMenu(previous => open ? {...previous, open} : CLOSED_MENU);
    }, []);

    return <StoreTotalsContextMenuContext.Provider value={openMenu}>
        {children}
        <DropdownMenu.Root open={menu.open} onOpenChange={onOpenChange}>
            <DropdownMenu.Trigger asChild>
                <div data-testid={'store-totals-context-menu-anchor'}
                     style={{position: 'fixed', left: menu.x, top: menu.y, width: 1, height: 1, pointerEvents: 'none'}}/>
            </DropdownMenu.Trigger>
            {menu.open && <ConfigUpdateContextMenu trigger={menu.trigger}/>}
        </DropdownMenu.Root>
    </StoreTotalsContextMenuContext.Provider>;
};

export default StoreTotalsContextMenuProvider;
